import apiClient from "./apiClient";

// 🔹 Create a new Lesson (includes HTML "notes")
export const createLesson = async (payload) => {
  const response = await apiClient.post("/lessons/", payload);
  return response.data;
};

// 🔹 Get all Lessons (optional filters like ?limit=10)
export const getLessons = async (params = {}) => {
  const response = await apiClient.get("/lessons", { params });
  return response.data;
};

// ✅ Get all Lessons for a specific Unit (matches Flask route)
export const getLessonsByUnit = async (unitId) => {
  const response = await apiClient.get(`/lessons/by_unit/${unitId}`);
  return response.data;
};

// 🔹 Get a single Lesson by ID
export const getLessonById = async (id) => {
  const response = await apiClient.get(`/lessons/${id}`);
  return response.data;
};

// 🔹 Update an existing Lesson
export const updateLesson = async (id, data) => {
  const response = await apiClient.put(`/lessons/${id}`, data);
  return response.data;
};

// 🔹 Delete a Lesson
export const deleteLesson = async (id) => {
  const response = await apiClient.delete(`/lessons/${id}`);
  return response.data;
};
